import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider, Toast } from "antd-mobile";
import zhCN from "antd-mobile/es/locales/zh-CN";
import WeComCoaching from "./wecom-h5/coaching/WeComCoaching.tsx";
import { H5ErrorBoundary } from "./wecom-h5/H5ErrorBoundary";
import { registerSW } from "./lib/registerSW";
import { initErrorReporting } from "@/shared/lib/errorReporting";
import { bootstrapBrand } from "@/shared/brand";
import { PartnerNotFoundGate } from "@/shared/brand/PartnerNotFoundGate";
import "@/shared/lib/i18n"; // i18n side-effect init(独立入口绕过 App.tsx,须自行加载翻译资源,否则 t() 显原始 key)
import "./index.css";
// 0519 v45: light theme override — 见 styles/wecom-h5-light.css 顶部注释
import "./styles/wecom-h5-light.css";
// 必须在任何 useGSAP 组件渲染前执行:否则 context 收不到 tween,卸载时漏动画。
import "@/shared/motion/registerGsap";

// 可观测性(契约 §4):未配 DSN 时只挂两个空监听器,load 后发现没配即卸掉;SDK 不进首屏。
initErrorReporting("wecom-h5");
registerSW();

// 0519 v45: 企微 H5 强制 light theme,跟 antd-mobile 亮色默认一致.
// 必须在 createRoot 之前设,否则首屏 cyber 暗色一闪.
document.documentElement.setAttribute("data-theme", "wecom-light");

// 企微 H5 entry — MEMBER 角色,独立 OAuth 流程,不接 AuthContext / ProtectedRoute(由 useWeComAuth 内部托管 token)
// audit-0713 C1a:查询错误零静默兜底(页面自渲染错误态的用 meta.suppressGlobalErrorToast 退订)
const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (_error, query) => {
      if (query.meta?.suppressGlobalErrorToast) return;
      Toast.show({ icon: "fail", content: "加载失败,请稍后重试" });
    },
  }),
  defaultOptions: { queries: { retry: 1, throwOnError: false } },
});

// OEM 贴牌:createRoot 之前落定品牌(缓存即用 / 渠道域名最多等 1500ms / 失败按直营白名单回落)。
void bootstrapBrand("wecom-h5").finally(() => {
  createRoot(document.getElementById("root")!).render(
    <PartnerNotFoundGate>
      <H5ErrorBoundary>
        <ConfigProvider locale={zhCN}>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter future={{ v7_relativeSplatPath: true }}>
              <Routes>
                <Route path="/wecom/coaching" element={<WeComCoaching />} />
                <Route path="*" element={<WeComCoaching />} />
              </Routes>
            </BrowserRouter>
          </QueryClientProvider>
        </ConfigProvider>
      </H5ErrorBoundary>
    </PartnerNotFoundGate>
  );
});
